// App name: GENERAL PURPOSE
// Description: Header, menu, panel

const GeneralApp = (function ($) {

  // variables
  var _body       = $('body');
  var _hamburger  = $('.hamburger');
  var _contactBtn = $('.open-contact');
  // init
  function init() {
    initHamburger();
    initContactForm();
    initCustomCursor();
    initPerlenListAnchor();

    // window scrolling
    window.onscroll = function() {
      if ( window.innerWidth >  1023 ) {
        stickyHeader(100);
      } else {
        stickyHeader(150);
      }
    }
  }

  //Sticky Header
  function stickyHeader(value) {
    if (!_body.hasClass('page-template-template-programmperlen')) {
      if (document.body.scrollTop > value || document.documentElement.scrollTop > value) {
        $('body').addClass('is-sticky');
      } else {
        $('body').removeClass('is-sticky');
      }
    }
  }

  function initHamburger() {
    _hamburger.on('click', function() {
      var _self = $(this);
      if (_self.hasClass('active')) {
        _self.removeClass('active');
        _body.removeClass('show-menu');
        _body.removeClass('show-contact');
      } else {
        _self.toggleClass('active');
        _body.toggleClass('show-menu');
      }
    });
  }

  function initContactForm() {
    _contactBtn.on('click', function() {
      _body.toggleClass('show-contact');
      _hamburger.addClass('active');
      if (_body.hasClass('show-menu')) {
        _body.removeClass('show-menu');
      }
    });
  }


  function initCustomCursor() {
    var cursor    = $('.cursor')[0];
    var _postItem = $('.bow-item');
    var _a        = $('a');

    if ("ontouchstart" in document.documentElement) {
      // Deactive custom cursor in touch device
      $('.cursor').hide();
    } else {
      $('.cursor').show();
      document.addEventListener('mousemove', function(e){
        var _posX = e.clientX;
        var _posY = e.clientY;
        cursor.style.transform = `translate3d(calc(${_posX}px - 50%), calc(${_posY}px - 50%), 0)`
      });

      initCursorHover(_postItem, 'hover-post');
    }
  }

  function  initPerlenListAnchor() {
    var _btn = $('.perlenlist-anchor-link a.elementor-icon');

    _btn.on('click', function(e) {
      e.preventDefault();
      var _target = $('.has-perlenlist .elementor-accordion-item:first-child .elementor-tab-title');
      _target.click();
    });
  }

  function initCursorHover(elem, className) {
    elem.each(function() {
      var _self = $(this);
      _self.on('mouseover', function() {
        $('.cursor').addClass(className);
      });

      _self.on('mouseleave', function() {
        $('.cursor').removeClass(className);
      });
    });
  }

  return {
    init: init,
  };
})(jQuery);

jQuery('document').ready(function () {
  GeneralApp.init();
});
